<template>
  <div>
    <heading v-if="step !== 'consent'">
      <small>Create account</small>
    </heading>
    <form-message v-if="message"
                  :severity="msgSeverity"
                  :message="message"/>

    <p v-if="step === 'profile'">
      Before we can sign you up we need to know a few things about you…
    </p>
    <profile-form v-if="step === 'profile'"
                 :email="email"
                 @submit="saveUserData">
    </profile-form>
    <consent-form v-if="step === 'consent'"
                  @submit="saveConsent">
    </consent-form>
    <password-form v-if="step === 'password'"
                   @submit="signup">
    </password-form>
    <code-form v-if="step === 'code'"
               @submit="submitCode">
    </code-form>

    <form-button v-if="step === 'done'"
                 :focus="true"
                 color="blue"
                 pull="right"
                 @click="$router.go(-1)">
      Sign in
    </form-button>
    <form-button v-else
                 pull="left"
                 @click="$router.go(-1)">
      Cancel
    </form-button>
  </div>
</template>

<script>
import { signup } from '../auth';

import Heading from './elements/Heading';
import FormButton from './elements/FormButton';
import FormMessage from './elements/FormMessage';

import ConsentForm from './forms/Consent';
import ProfileForm from './forms/Profile';
import PasswordForm from './forms/Password';
import CodeForm from './forms/VerificationCode';

export default {
  components: {
    Heading,
    FormButton,
    FormMessage,
    ConsentForm,
    ProfileForm,
    PasswordForm,
    CodeForm,
  },

  data() {
    return {
      step: 'profile',
      error: false,
      message: '',
      verifyMethod: null,
      userData: {},
    };
  },

  props: {
    email: { type: String, default: '' },
  },

  computed: {
    msgSeverity: function isError() {
      return this.error ? 'warning' : 'information';
    },
  },

  methods: {

    saveUserData({ email, givenName, familyName }) {
      this.userData = {
        email,
        given_name: givenName,
        family_name: familyName,
      };
      this.step = 'consent';
    },

    saveConsent({ consentDate }) {
      this.userData.consent_date = consentDate;
      this.step = 'password';
    },

    signup({ password }) {
      const self = this;

      signup({
        ...this.userData,
        password,
        error: (err) => {
          self.error = true;
          self.message = err;
        },
        verificationRequired: (verifyMethod) => {
          self.error = false;
          self.message = `Verification code sent to ${self.userData.email}, ` +
            'check your inbox and spam folder.';
          self.verifyMethod = verifyMethod;
          self.step = 'code';
        },
        success: () => {
          self.error = false;
          self.step = 'done';
          self.message = 'Account created, you can now sign in.';
        },
      });
    },

    submitCode({ code }) {
      this.verifyMethod({ code });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue